import styles from "./NewAssets.module.scss";
import newVolumeIcon from "../../../../assets/images/newVolumeIcon.svg";
import newTemplateIcon from "../../../../assets/images/newTemplateIcon.svg";
import newFolderIcon from "../../../../assets/images/newFolderIcon.svg";
import { NewAssetProps } from "./NewAsset";

interface AssetItem {
  imgSrc: string;
  alt: string;
  text: string;
  action: keyof NewAssetProps;
}

interface AssetsDropdownProps {
  actions: any;
  setIsOpen: (value: boolean) => void;
}

const assetItems: AssetItem[] = [
  {
    imgSrc: newVolumeIcon,
    alt: "volumeIcon",
    text: "New Volume",
    action: "createNewVolume",
  },
  {
    imgSrc: newTemplateIcon,
    alt: "templateIcon",
    text: "New Template",
    action: "createNewTemplate",
  },
  {
    imgSrc: newFolderIcon,
    alt: "folderIcon",
    text: "New Folder",
    action: "createNewFolder",
  },
];

const AssetsDropdown = ({
  actions,
  setIsOpen,
}: AssetsDropdownProps) => {
  const handleItemClick = (action: keyof typeof actions) => {
    actions[action]?.();
    setIsOpen(false);
  };

  return (
    <div className={styles.assetDropdown}>
      {assetItems.map(({ imgSrc, alt, text, action }) => (
        <div key={alt} className={styles.group} onClick={() => handleItemClick(action)}>
          <img src={imgSrc} alt={alt} className={styles.icon} />
          <span className={styles.itemText}>
            {text}
          </span>
        </div>
      ))}
    </div>
  );
};

export default AssetsDropdown;
